
/* System defined core library */
import { Injectable } from '@angular/core';

@Injectable()
export class CultureService {

  private kmPerMi: number = 1.609344;

  constructor() {
  }

  /**
    * Map a langauge code from PROScheduler to ISO standard. These are language codes in PROScheduler that are not 1:1 mapped to ISO.
    * @param languageCode
    */
  public mapLanguageCodeToISO(languageCode: string) {
    if (!languageCode) return '';

    let result: string = languageCode.toLowerCase();

    switch (result) {

      // PROScheduler Welsh to ISO Welsh
      case 'sw':
      case 'sw-ke':
        result = 'cy';
        break;
      case 'en-ie':
        result = 'gd';
        break;
    }

    return result;
  }

  /**
   * Convert a distance in miles to the equivalent disance in kilometers
   * @param miles
   */
  public convertMilesToKm(miles: number) {
    if (!miles) return 0;

    return miles * this.kmPerMi;
  }

  /**
   * Convert a distance in kilometers to the equivalent disance in miles
   * @param km
   */
  public convertKmToMiles(km: number) {
    if (!km) return 0;

    return km / this.kmPerMi;
  }
}
